// REACT
import React, { Component } from 'react';
import firebase from 'firebase/app';
import 'firebase/auth';
import { withRouter } from "react-router-dom";
// REDUX
import { connect } from "react-redux";
import { addUser, addFirebaseListeners, removeFirebaseListener } from "../../Actions/firebaseActions";
import { setToken } from '../../Actions/apiActions';
// COMPONENTS
import LogIn from '../Presentation/LogIn/LogIn';
import Register from '../Presentation/Register/Register';
import ForgotPassword from "../Presentation/ForgotPassword/ForgotPassword";
import Header from '../Presentation/Header/Header';
import PartnerFooter from '../Presentation/PartnerFooter/PartnerFooter';
import Policy from "../Presentation/Policy/Policy";

class LogInScreen extends Component {

	constructor(props) {
		super(props)

		this.state = {
			errorMsg: "",
			inputMode: "login",
			language: "english",
			logInOK: false,
			showLoader: false
		}
	}

	componentDidMount() {
		let componentState = this
		firebase.auth().onAuthStateChanged(function (user) {
			if (user) {
				componentState.setState({ logInOK: true })
			} else {
				componentState.setState({ logInOK: false })
			}
		});
	}

	componentDidUpdate() {
		if (this.state.logInOK && this.props.language !== undefined) {
			console.log("logInOK: ", this.state.logInOK, " language: ", this.props.language)
			this.props.history.push('/MainScreen')
		}
	}

	componentWillUnmount() {
		if (this.state.logInOK) {
			this.setState({ logInOK: false })
		}
	}

	emptyErrorMsg = () => {
		if (this.state.errorMsg !== "") {
			this.setState({ errorMsg: "" })
		}
	}

	onLogIn = (email, password) => {
		let componentState = this
		this.setState({ showLoader: true })
		firebase.auth().signInWithEmailAndPassword(email, password).then(() => {
			let uid = firebase.auth().currentUser.uid
			componentState.props.setToken()
			componentState.props.addFirebaseListeners(uid)
		}).catch(function (error) {
			// If error..	
			componentState.setState({ showLoader: false, errorMsg: error.message })
			console.log(componentState.state.errorMsg)
		});
	}

	onRegister = (email, password) => {
		let componentState = this
		firebase.auth().createUserWithEmailAndPassword(email, password).then(() => {
			let uid = firebase.auth().currentUser.uid
			componentState.props.addUser(uid, email, componentState.state.language)
			componentState.setState({ inputMode: "login" })
		}).catch(function (error) {
			// If error..
			componentState.setState({ errorMsg: error.message })
			console.log(componentState.state.errorMsg)
		});

	}

	onForgotPassword = (email) => {
		let componentState = this
		firebase.auth().sendPasswordResetEmail(email).then(() => {
			console.log("Password Sent to email")
			componentState.setState({ errorMsg: "Reset link sent to email!" })
		}).catch(function (error) {
			// If error..
			componentState.setState({ errorMsg: error.message })
			console.log(componentState.state.errorMsg)
		});

	}

	toggleInputMode = (input) => {
		this.setState({ errorMsg: "", inputMode: input })
	}

	setLanguage = (language) => {
		this.setState({ language: language })
	}

	render() {
		let input = <LogIn
			onLogIn={this.onLogIn}
			toggleInputMode={this.toggleInputMode}
			callback={this.authLogIn}
			errorTxt={this.state.errorMsg}
			language={this.state.language}
			showLoader={this.state.showLoader}
			emptyErrorMsg={this.emptyErrorMsg} />
		if (this.state.inputMode === "register") {
			input = <Register
				toggleInputMode={this.toggleInputMode}
				onRegister={this.onRegister}
				errorTxt={this.state.errorMsg}
				language={this.state.language} />
		}
		if (this.state.inputMode === "policy") {
			input = <Policy
				toggleInputMode={this.toggleInputMode}
				language={this.state.language} />
		}
		if (this.state.inputMode === "forgotPassword") {
			input = <ForgotPassword
				toggleInputMode={this.toggleInputMode}
				onForgotPassword={this.onForgotPassword}
				errorTxt={this.state.errorMsg}
				language={this.state.language} />
		}
		return (
			<div className="LogInScreen">
				<Header isLoggedIn={false} showFlagIcon={true} language={this.state.language} setLanguage={this.setLanguage} />
				{input}
				<PartnerFooter isLoggedIn={false} language={this.state.language} toggleInputMode={this.toggleInputMode} />
			</div>
		);
	}
}

const mapStateToProps = state => ({
	user: state.user,
	language: state.firebase.language,
	firebase: state.firebase,
	screenMode: state.mainScreen.mainScreenMode
});

const mapDispatchToProps = dispatch => {
	return {
		addUser: (uid, email, language) => dispatch(addUser(uid, email, language)),
		setToken: () => dispatch(setToken()),
		addFirebaseListeners: (uid) => dispatch(addFirebaseListeners(uid)),
		removeFirebaseListener: (uid) => dispatch(removeFirebaseListener(uid))
	}
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(LogInScreen));